import React, {useEffect} from 'react';
import {Button} from '../components/Button';
import {H2} from '../components/H2';
import {useHistory} from "react-router-dom";


export const SignupSuccessPage = () => {
    const {push} = useHistory();
    useEffect(() => {

    }, []);

    return (
        <div className="max-w-lg mx-auto md:px-4 space-y-6 my-8">
            <ul className={`grid grid-cols-3 h-0.5 bg-gray-100`}>
                <li className={`bg_3e52bb`}></li>
                <li className={`bg_3e52bb`}></li>
                <li className={`bg_3e52bb animate-width`}></li>
            </ul>
            <div className={`space-y-2`}>
                <H2 className="font-normal text-14 font-bold pt-2">회원가입 완료</H2>
                <div className={`leading-5 text-12 text-gray-600`}>
                    주식회사 웍스아웃 통합회원 가입이 완료 되었습니다.<br/>
                    앞으로 아래와 같은 서비스를 이용하실 수 있습니다.
                </div>
                <H2 className="font-normal text-14 font-bold pt-2">쿠폰 혜택을 받으실 수 있습니다.</H2>
                <div className={`leading-5 text-12 tx_3e52bb`}>
                    <button
                        onClick={() => push(`/journal/330`)}
                        className={`text-left`}
                    >
                        →&nbsp;<span className={`underline`}>웰컴 5% 쿠폰 이용하기</span>
                    </button>
                </div>
                <H2 className="font-normal text-14 font-bold pt-2">적립금 적립 및 사용 혜택을 받으실 수 있습니다.</H2>
                <div className={`leading-5 text-12 text-gray-900 flex flex-col`}>
                    → 온라인 및 오프라인 구매 시 1% 적립금 적립<br/>
                    → 온라인 구매 시 적립금 사용가능 (오프라인 불가)
                </div>
                <H2 className="font-normal text-14 font-bold pt-2">회원 전용 상품 및 구매 제한 상품을 이용하실 수 있습니다.</H2>
                <H2 className="font-normal text-14 font-bold pt-2">응모를 통하여 한정 상품을 구매 하실 수 있습니다.</H2>
                <div className={`space-y-4 pt-4`}>
                    <Button
                        to="/cc/custom/5"
                        text="더 자세한 회원 혜택 바로가기"
                        className="w-full text-12 h-9 border border-gray-300"
                    />
                    <Button
                        to="/login"
                        text="로그인 하기"
                        className="filled-gray-900 w-full text-12 font-light h-9"
                    />
                </div>
            </div>
        </div>
    );
};
